import React, { useCallback } from 'react';
import ReactDOM from 'react-dom';

import { Tabs, Icon } from 'antd';
import { ComplexVersionTabsContainer } from './styles';
import { CONTEXT_KEYS, useArtboardContext } from '../../../context/complexArtboardContext';
import { useVersionContext, VERSION_CONTEXT_KEYS } from '../../../context/complexVersionContext';
import { VersionSettings } from './VersionSettings';
import { DownloadButton } from '../styles';
import VersionsAudit from './VersionsAudit';
import { VERSION_SETTINGS_SIDEBAR } from './translationValues';
import { useTranslation } from 'react-i18next';
import { COMPLEX_DOCUMENT_CONTEXT_KEYS, useDocumentContext } from '../../../context/complexDocumentContext';
import ComplexEmailProvider from '../../../context/complexEmailContext';

const NAMESPACE = ['VERSION_SETTINGS_SIDEBAR'];

const TabPane = Tabs.TabPane;

const EmailContextProvider = ({children, isEmailTemplate}) => !isEmailTemplate ? <ComplexEmailProvider>{children}</ComplexEmailProvider> : <>{children}</>

const VersionSidebarTabContainer = () => {
  const { t } = useTranslation(NAMESPACE);
  
  const lifecycleSelector = useCallback(
    store => store[VERSION_CONTEXT_KEYS.LIFECYCLE_TIMELINE],
    [],
  );
  const [lifeCycle] = useVersionContext(lifecycleSelector, `VersionSidebarTabContainer`);

  const currentVisibleVersionSelector = useCallback(
    store => store[VERSION_CONTEXT_KEYS.CURRENT_VISIBLE_VERSION],
    [],
  );
  const [currentVisibleVersion, updateVersionStore] = useVersionContext(
    currentVisibleVersionSelector,
  );
  
  const isEmailSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.IS_EMAIL_TEMPLATE], []);
  const [isEmailTemplate] = useDocumentContext(isEmailSelector, `VersionSettingsSidebar`);
  

  return (
    <EmailContextProvider isEmailTemplate={isEmailTemplate}>
    <ComplexVersionTabsContainer>
      <Tabs tabBarStyle={{ color: 'white' }}>
        <TabPane
          tab={t(
            VERSION_SETTINGS_SIDEBAR.VERSIONS_TAB.key,
            VERSION_SETTINGS_SIDEBAR.VERSIONS_TAB.value,
          )}
          key="1"
        >
          <VersionSettings
            lifeCycle={lifeCycle}
            currentVisibleVersion={currentVisibleVersion}
            updateVersionStore={updateVersionStore}
          />
        </TabPane>
        <TabPane
          tab={t(VERSION_SETTINGS_SIDEBAR.AUDIT_TAB.key, VERSION_SETTINGS_SIDEBAR.AUDIT_TAB.value)}
          key="2"
        >
          <VersionsAudit />
        </TabPane>
      </Tabs>
    </ComplexVersionTabsContainer>
    </EmailContextProvider>
  );
};

export const VersionSettingsSidebar = () => {
  const artboardVersionSelector = useCallback(store => store[CONTEXT_KEYS.ARTBOARD_VERSION], []);
  const [artboardVersion] = useArtboardContext(artboardVersionSelector, 'VersionSettingsSidebar');
  return (
    <>
      {document.getElementById(`sidebar-absolute-container-version-${artboardVersion}`) &&
        ReactDOM.createPortal(
          <VersionSidebarTabContainer />,
          document.getElementById(`sidebar-absolute-container-version-${artboardVersion}`),
        )}
    </>
  );
};
